<template>
  <v-container>
    <h3>対象者・協力者</h3>
    <v-layout row　align-center v-if="auths.includes('EditSurveyUsers')">
      <v-flex md3>
        <v-btn color="cyan" class="white--text" :disabled="file==null" @click="importFile">
          <v-icon color="white">backup</v-icon>インポート
        </v-btn>
      </v-flex>
      <v-flex md3>
        <input type="file" @change="selectedFile" />
      </v-flex>
      <v-flex md3>
        <v-btn color="red" class="white--text" @click="deleteAllAnswers">
          <v-icon color="white">delete</v-icon>全削除
        </v-btn>
      </v-flex>
      <v-flex md3>
        <v-btn color="green" class="white--text" @click="downloadUsersFile">
          <v-icon color="white">cloud_download</v-icon>ダウンロード
        </v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-if="showDialog" v-model="selectedAnswer" :fullscreen="true">
      <edit-user v-model="selectedAnswer" @closeDialog="showDialog=false" />
    </v-dialog>

    <v-dialog v-model="showUrl" max-width="80%">
      <v-card>
        <v-card-title class="headline">URL 確認</v-card-title>

        <v-card-text>
          <p class="line-break">{{selectedUrl}}</p>
        </v-card-text>

        <v-card-actions>
          <v-btn color="green darken-1" flat="flat" @click="showUrl = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showSendMail" max-width="80%">
      <v-card>
        <v-card-title class="headline">URL 再送</v-card-title>

        <v-card-text>
          <v-text-field label="件名" v-model="mailSubject"></v-text-field>
          <v-textarea v-model="mailBody" label="本文" auto-grow></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-btn color="green darken-1" flat="flat" @click="sendMail()">送信</v-btn>

          <v-btn color="green darken-1" flat="flat" @click="showSendMail = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :items="answerItems"
      :headers="headers"
      class="elevation-1"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      rows-per-page-text="表示行"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{props.item.subject_name}}</td>
          <td>{{props.item.job}}</td>
          <td>{{props.item.position}}</td>
          <td>{{props.item.name}}</td>
          <td>{{getSurveyType(props.item.type)}}</td>
          <td>{{props.item.status}}</td>
          <td>
            <v-btn small @click.stop="showSurveyUrl(props.item.id)">URL確認</v-btn>
            <v-btn small @click.stop="openSendMail(props.item)">URL再送</v-btn>
            <v-btn small @click.stop="toSurveyUrl(props.item.id)">代行入力</v-btn>
            <v-btn
              small
              @click.stop="deleteAnswers(props.item)"
              v-if="auths.includes('EditSurveyUsers')"
            >削除</v-btn>
          </td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="props"
      >{{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示</template>
    </v-data-table>
  </v-container>
</template>
<script>
import db from "@/components/firebaseInit";
import EditUser from "@/components/manage_survey/editUser.vue";
import {
  getUnixtime,
  unixtimeToJapaneseFormattedDate
} from "@/utils/datetime.js";
import XLSX from "xlsx";
const chance = require("chance");
import { mapMutations, mapGetters } from "vuex";

const headerOfUserTable = {
  A1: { t: "s", v: "No", w: "No" },
  B1: { t: "s", v: "name", w: "name" },
  C1: { t: "s", v: "email", w: "email" },
  D1: { t: "s", v: "position", w: "position" },
  E1: { t: "s", v: "job_id", w: "job_id" },
  F1: { t: "s", v: "job", w: "job" }
};
const headerOfSurveyTable = {
  A1: { t: "s", v: "No", w: "No" },
  B1: { t: "s", v: "subject_name", w: "subject_name" },
  C1: { t: "s", v: "subject_email", w: "subject_email" },
  D1: { t: "s", v: "name", w: "name" },
  E1: { t: "s", v: "email", w: "email" }
};
const newChallengeSheet = {
  plans: [
    {
      approve_comment: "",
      approve_status: true,
      method: "",
      plan: "",
      rater_comment: "",
      self_comment: "",
      self_point: ""
    },
    {
      approve_comment: "",
      approve_status: true,
      method: "",
      plan: "",
      rater_comment: "",
      self_comment: "",
      self_point: ""
    },
    {
      approve_comment: "",
      approve_status: true,
      method: "",
      plan: "",
      rater_comment: "",
      self_comment: "",
      self_point: ""
    }
  ],
  position: "",
  status: "未完了",
  user_id: "",
  user_name: ""
};
export default {
  components: { EditUser },
  props: {
    answerItems: {}
  },
  data() {
    return {
      items: [],
      users: [],
      headers: [
        { text: "対象者名", value: "subject_name", sortable: true },
        { text: "対象者職種", value: "job", sortable: false },
        { text: "対象者役職", value: "position", sortable: false },
        { text: "回答者名", value: "name", sortable: true },
        { text: "サーベイタイプ", value: "type", sortable: true },
        { text: "ステータス", value: "status", sortable: true },
        { text: "操作", sortable: false }
      ],
      answerDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("answer_sheets"),
      mailDbRef: db.collection("mails"),
      showDialog: false,
      newAnsewer: {
        email: "",
        name: "",
        result: {},
        status: "未実施",
        subject_id: "",
        subject_name: "",
        type: "coWorker"
      },
      selectedAnswer: {},
      subject: {},
      user: {},
      rowsPerPageItems: [25, 50, 100],
      pagination: {
        rowsPerPage: 25
      },
      showUrl: false,
      showSendMail: false,
      selectedUrl: "",
      mailBody: "\r\n URLを再送します。",
      mailSubject: "サーベイURLの再送",
      selectedItem: {},
      file: null,
      workbook: null
    };
  },
  computed: {
    ...mapGetters("auth", ["auths"])
  },
  watch: {
    subject() {
      this.selectedAnswer.subject_id = this.subject.id;
      this.selectedAnswer.subject_name = this.subject.name;
      if (this.selectedAnswer.subject_id.type == "subject") {
        this.selectedAnswer.name = this.subject.name;
        this.selectedAnswer.email = this.subject.email;
      }
    },
    user() {
      this.selectedAnswer.name = this.user.name;
      this.selectedAnswer.email = this.user.email;
    }
  },
  methods: {
    async deleteAnswers(ans) {
      await this.answerDbRef
        .doc(ans.id)
        .delete()
        .catch(e => {
          console.error("Error removing document: ", e);
        });
    },
    async deleteAllAnswers() {
      const is_ok =window.confirm('保存を実行してもよろしいですか？');
      if(!is_ok){
        return;
      }
      const promises = [];
      this.answerItems.forEach(item => {
        try {
          const p = this.answerDbRef.doc(item.id).delete();
          promises.push(p);
        } catch (e) {
          console.error("Error removing document: ", e);
        }
      });
      Promise.all(promises);
    },
    addAnswers() {
      this.selectedAnswer = JSON.parse(JSON.stringify(this.newAnsewer));
      this.showDialog = true;
    },
    createAnswers() {
      this.answerDbRef.add(this.selectedAnswer);
      this.showDialog = false;
    },
    getSurveyType(type) {
      return type == "subject" ? "本人" : "協力者";
    },
    getSurveyUrl(id) {
      return (
        window.location.origin +
        "/" +
        this.$router.resolve({
          name: "answer",
          params: {
            company_id: this.$route.params.company_id,
            survey_id: this.$route.params.survey_id,
            answer_sheet_id: id
          }
        }).href
      );
    },
    showSurveyUrl(id) {
      this.selectedUrl = this.getSurveyUrl(id);
      this.showUrl = true;
    },
    toSurveyUrl(id) {
      let routeData = this.$router.resolve({
        name: "answer",
        params: {
          company_id: this.$route.params.company_id,
          survey_id: this.$route.params.survey_id,
          answer_sheet_id: id
        }
      });
      window.open(routeData.href, "_blank");
    },
    openSendMail(item) {
      this.selectedItem = item;
      this.mailBody =
        item.name +
        " 様 \r\n\r\nサーベイURLを再送します。\r\nご協力お願い致します。\r\n\r\n";
      this.mailBody = this.mailBody + this.getSurveyUrl(item.id);
      this.showSendMail = true;
    },
    async sendMail() {
      const mail = {};
      mail.subject = this.mailSubject;
      mail.body = this.mailBody;
      mail.to = this.selectedItem.email;
      mail.sending_time = getUnixtime();
      mail.was_sent = false;
      mail.company_id = this.$route.params.company_id;
      try {
        const docRef = await this.mailDbRef.add(mail);
        console.log("Document written with ID: ", docRef.id);
        this.showSendMail = false;
      } catch (e) {
        console.log(e);
      }
    },
    selectedFile(e) {
      e.preventDefault();
      this.file = e.target.files[0];
    },
    importFile() {
      this.changeLoadingState(true);
      const reader = new FileReader();
      reader.readAsArrayBuffer(this.file);
      reader.onload = e => {
        const data = new Uint8Array(reader.result);
        this.workbook = XLSX.read(data, { type: "array" });

        this.importUserTable(this.workbook.Sheets["対象者一覧"]);

        this.changeLoadingState(false);
      };
    },
    importUserTable(worksheet) {
      
      for (let key of Object.keys(headerOfUserTable)) {
        worksheet[key] = headerOfUserTable[key];
      }
      const items = XLSX.utils.sheet_to_json(worksheet);
      this.createUsers(
        items.filter(item => {
          return "name" in item && "email" in item;
        })
      );
    },
    importSurveyTable(worksheet, subjectUsers) {
      for (let key of Object.keys(headerOfSurveyTable)) {
        worksheet[key] = headerOfSurveyTable[key];
      }
      const items = XLSX.utils.sheet_to_json(worksheet);
      this.createSurveys(
        items.filter(item => {
          return (
            "subject_name" in item &&
            "subject_email" in item &&
            "name" in item &&
            "email" in item
          );
        }),
        subjectUsers
      );
    },
    async createUsers(items) {
      await this.reloadUsers();
      const dbRef = db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("users");
      const promises = [];
      this.errorMessages = [];
      items.forEach(item => {
        const user = {
          name: item.name,
          email: item.email,
          first_password: chance().string({
            length: 6,
            pool:
              "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@$%"
          })
        };
        const duplicate = this.ensureDuplicateUser(user);
        if (duplicate == "no-duplicate") {
          try {
            const p = dbRef.add(user);
            promises.push(p);
          } catch (e) {
            console.log(e);
          }
        } else {
          this.errorMessages.push(
            `Eメールアドレス:${user.email}は、異なる生年月日のユーザーが登録されています。\n同じメールアドレスで２人のユーザーを登録することはできません。\nユーザーを削除してから再度登録してください。`
          );
        }
      });
      await Promise.all(promises);
      this.importSurveyTable(this.workbook.Sheets["サーベイリスト"], items);
    },
    async createSurveys(items, subjectUsers) {
      ;
      const promises = [];
      await this.reloadUsers();
      const subjectUsersDic = {};
      subjectUsers.forEach(subject => {
        console.log(this.users)
        
        const subjectUser = this.users.find(
          user => user.email == subject.email
        );
        if(subjectUser==undefined){
          this.errorMessages.push(
            `Eメールアドレス:${subject.email}のユーザーが見つかりませんでした。登録されているか確認してください。`
          );
          throw new Error("Not found subject user")
        }
        subjectUsersDic[subject.email] = {
          ...subject,
          subject_id: subjectUser.id,
          subject_name: subject.name
        };

        const newAnswer = JSON.parse(JSON.stringify(this.newAnsewer));
        const answer = {
          ...newAnswer,
          ...subjectUsersDic[subject.email],
          name: subject.name,
          type: "subject"
        };
        try {
          const p = this.answerDbRef.add(answer);
          promises.push(p);
        } catch (e) {
          this.errorMessages.push(crudErrorCodeToMessage(e.code));
          console.log(e);
        }
        ;
        const newCS = JSON.parse(JSON.stringify(newChallengeSheet));
        ;
        const challengeSheet = {
          ...newCS,
          ...subjectUsersDic[subject.email],
          name: subject.name,
          survey_id: this.$route.params.survey_id
        };
        const p = db
          .collection("companies")
          .doc(this.$route.params.company_id)
          .collection("challenge_sheets")
          .add(challengeSheet);
        promises.push(p);
      });
      items.forEach(item => {
        const newAnswer = JSON.parse(JSON.stringify(this.newAnsewer));
        const answer = {
          ...newAnswer,
          ...subjectUsersDic[item.subject_email],
          email: item.email,
          name: item.name
        };

        try {
          const p = this.answerDbRef.add({ ...newAnswer, ...answer });
          promises.push(p);
        } catch (e) {
          this.errorMessages.push(crudErrorCodeToMessage(e.code));
          console.log(e);
        }
      });
      await Promise.all(promises);
    },
    async reloadUsers() {
      const dbRef = db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("users");
      const users = await dbRef.get();
      this.users = [];
      users.forEach(doc => {
        this.users.push({ ...doc.data(), id: doc.id });
      });
      return true;
    },
    ensureDuplicateUser(user) {
      const duplicateUser = this.users.find(u => {
        return user.email == u.email;
      });
      if (duplicateUser) {
        return "duplicate-email";
      } else {
        return "no-duplicate";
      }
    },
    downloadUsersFile() {
      var FileSaver = require("file-saver");
      var workbook = { SheetNames: [], Sheets: {} };
      var wopts = { bookType: "xlsx", bookSST: false, type: "array" };

      /* Push headers */
      const subjectsData = [["status", "name", "email", "url"]];
      const coworkersData = [
        ["status", "subject_name", "name", "email", "url"]
      ];

       /* Push rows */
      this.answerItems.forEach(ans => {
        if (ans.type == "subject") {
          subjectsData.push([
            ans.status,
            ans.name,
            ans.email,
            this.getSurveyUrl(ans.id)
          ])
        } else {
          coworkersData.push([
            ans.status,
            ans.subject_name,
            ans.name,
            ans.email,
            this.getSurveyUrl(ans.id)
          ]);
        }
      });

      /* Add the worksheets to the workbook */
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(subjectsData), "subjects");
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(coworkersData), "coworkers");

      var wbout = XLSX.write(workbook, wopts);
      var blob = new Blob([wbout], { type: "application/octet-stream" });
      FileSaver.saveAs(blob, "survey_users.xlsx");
    },
    ...mapMutations("app", ["changeLoadingState"])
  }
};
</script>

<style lang="scss" scoped>

.line-break { word-wrap: break-all; }

</style>
